<template>
  <CRow>
    <CCol col="12">
      <CButtonToolbar>
        <CButton size="lg" color="ghost-success" shape="pill" @click="$router.push({name: 'New BoMember',})"><CIcon size="lg" name="cil-plus"/></CButton>
      </CButtonToolbar>
    </CCol>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <CDataTable
            outlined
            hover
            striped
            tableFilter
            columnFilter
            sorter
            :fields="boMembersUiMeta"
            :items="boMembers"
            :items-per-page="20"
            clickable-rows
            :active-page="activePage"
            @row-clicked="rowClicked"
            :pagination="{ align: 'center'}"
            @page-change="pageChange"
            :noItemsView="{ noResults: i18nMessage.NoFilteredResultsAvailable, noItems: i18nMessage.NoItemsAvailable }"
          >
            <template #modules="{item}">
              <td>
                {{item.modules && item.modules.length > 0 ? item.modules.join(', ') : ''}}
              </td>
            </template>
            <template #updated_at="{item}">
              <td>
                {{item.updated_at ? new Date(item.updated_at).format('yyyy-MM-dd hh:mm:ss') : ''}}
              </td>
            </template>
            <template #created_at="{item}">
              <td>
                {{item.created_at ? new Date(item.created_at).format('yyyy-MM-dd hh:mm:ss') : ''}}
              </td>
            </template>
          </CDataTable>
          <div style="text-align: center; color: #4f5d73">{{i18nMessage.TotalRows}}: {{boMembers.length}}</div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'

export default {
  name: 'BoMembers',
  data () {
    return {
      activePage: 1,
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      boMembers: state => state.boMember.boMembers,
      boMembersUiMeta: state => state.boMember.boMembersUiMeta,
    }),
  },
  methods: {
    ...mapActions({
      listBoMembers: 'boMember/listBoMembers',
    }),
    ...mapMutations({
      setBoMembers: 'boMember/setBoMembers',
    }),
    rowClicked (item) {
      this.$router.push({path: `bo-member/${item.invisible_id}`})
    },
    pageChange (val) {
      this.$router.push({ query: { page: val }})
    },
  },
  created () {
  },
  mounted () {
    this.listBoMembers()
  },
  destroyed () {
    this.setBoMembers([])
  },
  watch: {
    $route: {
      immediate: true,
      handler (route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page)
        }
      }
    }
  },
}
</script>